/* @flow */

import * as React from 'react';
import moment from 'moment';
import range from 'lodash/range';
import t from 'app/utils/translate';
import SelectField from './SelectField';

type Props = {
  disabled?: boolean,
  defaultText?: string,
  lightContent?: boolean,
  onChange: string => void,
  options?: Array<*>,
  required?: boolean,
  size?: string,
  value?: string,
};

const defaultProps = {
  disabled: false,
  defaultText: t('Year'),
  lightContent: false,
  options: range(moment().year() - 18, 1900),
  required: false,
  size: undefined,
  value: '',
};

function YearSelectField({
  disabled,
  defaultText,
  lightContent,
  onChange,
  options,
  required,
  size,
  value,
}: Props) {
  return (
    <SelectField
      disabled={disabled}
      defaultText={defaultText}
      name="year"
      options={options}
      onChange={onChange}
      required={required}
      size={size}
      value={value}
      lightContent={lightContent}
    />
  );
}

YearSelectField.defaultProps = defaultProps;

export default YearSelectField;
